import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ModalService } from "../../../shared/modal/modal.service";
import { UserAPI } from "../../../../model";
import { UserApiService } from "../../../../services/userapi/userapi.service";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "../../../shared/message/message.service";
import { UserService } from "../../../../services/user/user.service";

@Component({
  standalone: false,
  selector: 'app-userapi-shared-non-oauth',
  // Deliberately Eager (COMBI-4468): the parent forms mutate userApi.configured in place, also from a
  // child's ngOnInit. OnPush would miss that and keep the "test & save" button disabled; Eager reads it
  // live whenever the parent is checked (which also works zoneless).
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './userapi-shared-non-oauth.component.html'
})
export class UserApiSharedNonOAuthComponent {
  @Input() userApi: UserAPI;
  constructor(protected messageService: MessageService,
              protected userApiService: UserApiService,
              protected userService: UserService,
              protected translate: TranslateService,
              protected modalService: ModalService<any>) {
  }

  async testUserApi() {
    const savedUserAPI = await this.userApiService.testAndSaveUserApi(this.userApi, this.userService.getUser());
    if (!!savedUserAPI) {
      this.messageService.showSuccessMessage(this.translate.instant("MODAL_USERAPI_CONNECTION_SUCCESSFUL"));
      this.modalService.close(savedUserAPI);
    }
  }
}
